import DialogComponent from "../../../components/Dialog";

/**
 * Created by viclight on 05.03.2024.
 */
export default class RecoveryPasswordDialog extends DialogComponent {

    title = "employee.titleRecoveryPassword";

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            id: null,
        };
    }

    show(id, saveCb) {
        this.state.id = id || null;
        this.saveCb = saveCb;

        super.show();
    }

    save() {
        this.hide();

        if (this.saveCb?.apply)
            this.saveCb(this.state.id || null);
    }

    renderContent() {
        return (
            <div className="content">
                Dialog Content
            </div>
        );
    }


}
